import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { teamMemberQuery } from './get-team-member-list';
import { teamQuery } from './team';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useDeleteTeamMember() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { teamId, memberId, queryParams } = param;
            return axios.delete("/v2/team/".concat(teamId, "/member/").concat(memberId));
        },
        onSuccess: async (res, param)=>{
            let { teamId, queryParams } = param;
            const invalidateQueryPromises = [
                queryClient.invalidateQueries(teamQuery.getById(teamId)),
                queryClient.invalidateQueries(teamQuery.getByOrganizationIdAndName(queryParams === null || queryParams === void 0 ? void 0 : queryParams.organizationName, queryParams === null || queryParams === void 0 ? void 0 : queryParams.teamName)),
                queryClient.invalidateQueries(teamMemberQuery.list(teamId, {
                    name: queryParams === null || queryParams === void 0 ? void 0 : queryParams.name
                }))
            ];
            await Promise.all(invalidateQueryPromises);
        }
    });
}
